import { useState, useEffect, useRef } from 'preact/hooks';
import { Spinner } from '@/components';
import { SvgIcon, useConfigStore } from '@/features/form';
import { showConversationalError } from '../utils';
import { makeClassName } from '@/utils';

export default function CommentBar({
	skipQuestion,
	block,
	elementIndex,
	state,
	setValue,
	autoFocus,
	errorMessage,
	...props
}) {
	const [inputValue, setInputValue] = useState(state.value);
	const inputRef = useRef(null);
	const { text } = useConfigStore();
	const error = showConversationalError({ block, state });

	function handleUpdate() {
		if (block.properties.required || inputValue) {
			setValue(inputValue);
		}

		if (!block.properties.required && !inputValue) {
			skipQuestion();
		}
	}

	useEffect(() => {
		try {
			inputRef.current.focus();
		} catch (e) {}
	}, []);

	const id = `element-${block.typeName ?? ''}-${block.id ?? block.data_field}`;

	return (
		<div className={makeClassName('comment-bar-wrap')}>
			{/* use dummy label, real one is in the wrong spot in the document tree for screenreaders */}
			<label
				for={id}
				className={makeClassName('comment-bar-hidden-label')}
			>
				{block.title}
			</label>
			<textarea
				className={makeClassName(
					'comment-bar',
					error ? { prefix: false, className: 'error' } : null
				)}
				id={id}
				value={inputValue}
				onInput={e => setInputValue(e.target.value)}
				ref={inputRef}
				placeholder={block.properties?.placeholder || ''}
			/>
			{state?.isLoading && <Spinner />}
			<button
				type="button"
				className={makeClassName(
					{ prefix: false, className: 'btn' },
					{ prefix: false, className: 'btn btn-primary' },
					'comment-bar-button'
				)}
				onClick={handleUpdate}
				aria-label={text?.wcag?.inputSendButtonDescription ?? 'send'}
			>
				<SvgIcon
					icon="paper-plane-o"
					alt={text?.wcag?.inputSendButtonDescription ?? 'send'}
				/>
			</button>
		</div>
	);
}
